import { ColorContrastRequirements } from "client/Components/ColorPicker/BaseColorPicker";
import { calculateRelativeLuminance, cssColorToRgb, getContrastRatio, RgbColor } from "client/Misc/colorFunctions";
import { isNotNil } from "client/Misc/utils";
import { localize } from "client_legacy/ndaw/culture";
import { InputValidationResult, InputValidationResultKind } from "../input";
import { ValidationRuleTriggers } from "./triggers";

export class HasContrastRequirementsRule extends ValidationRuleTriggers<string | null> {
	private readonly _minimumRequiredContrastRatio: number;
	private readonly _compareAgainstLuminances: readonly number[];
	private readonly _alternativeMessage: string | undefined;

	constructor (contrastRequirements: ColorContrastRequirements, alternativeMessage?: string) {
		super();
		this._minimumRequiredContrastRatio = contrastRequirements.minimumRequiredContrastRatio;
		this._compareAgainstLuminances = contrastRequirements.compareAgainst
			.map(cssColorToRgb)
			.filter(isNotNil)
			.map(calculateRelativeLuminance);

		this._alternativeMessage = alternativeMessage;
	}

	public validate(value: string | null): InputValidationResult {
		if (!value) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		const rgb: RgbColor | undefined = cssColorToRgb(value);
		if (!rgb) {
			return {
				kind: InputValidationResultKind.Valid
			};
		}

		const hasRequiredContrastRatio: boolean = this._compareAgainstLuminances
			.map(l => getContrastRatio(rgb, l))
			.every(c => c >= this._minimumRequiredContrastRatio);

		if (!hasRequiredContrastRatio) {
			return {
				kind: InputValidationResultKind.Invalid,
				errorMessage: (this._alternativeMessage || localize("_TheSelectedColorDoesntMeetAccessibilityStandardsPleaseSelectInfo"))
			};
		}

		return {
			kind: InputValidationResultKind.Valid
		};
	}
}
